import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabsFetchFailed } from 'state/workspaces/workspace.actions';
import { workspaceTabsFetchedThunk } from 'state/workspaces/workspace.thunks';

export function fetchStaticWorkspaceTabsEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const api = tabsApiConnector(httpClient, 'static');
    return action$.pipe(
      ofType('WORKSPACE_TABS_FETCH_REQUESTED'),
      filter(({ workspace }) => workspace === 'static'),
      mergeMap(({ tabFetchRequestId }) =>
        api.getAllTabDescriptions().pipe(
          map(({ tabs, activeTabId }) => {
            const actualActiveTabId: string | undefined = activeTabId ?? tabs[0]?.id ?? undefined;
            return workspaceTabsFetchedThunk(tabs, actualActiveTabId, 'static', tabFetchRequestId);
          }),
          catchError((_: Error) => {
            return of(workspaceTabsFetchFailed('static', tabFetchRequestId));
          }),
        ),
      ),
    );
  };
}
